<template>
  <div v-show=" data.report.employees.length > 0">
    <table class="table table-condensed table-striped standard-report frozen-table">
      <thead>
        <tr class="table-header header text-left">
          <th>
            <span class>Employee</span>
          </th>
          <th
            class="text-right"
            style="white-space: pre-line;"
            v-for="p in data.report.promos"
            :key="p.id"
          >{{ p.name }}</th>
          <th class="text-right">
            <span class>
              Total
              <br />Promos
            </span>
          </th>
          <th class="text-right">
            <span class>
              % of
              <br />Sales
            </span>
          </th>
          <th class="text-right">
            <span class>
              Total
              <br />Voids
            </span>
          </th>
          <th class="text-right">
            <span class>
              % of
              <br />Sales
            </span>
          </th>
          <th class="text-right">
            <span class>
              Total
              <br />Tips
            </span>
          </th>
          <th class="text-right">
            <span class>
              % of
              <br />Sales
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="border-right"
          v-for="v in data.report.employees"
          :key="v.id"
          v-show="data.report.employees.length > 0"
        >
          <td>{{ v.employeename }}</td>
          <td class="text-right" v-for="p in data.report.promos" :key="p.id">
            <span v-show="v.promos.hasOwnProperty(p.id)">
              <sales-check-list-modal
                :locationId="locationId"
                :startDate="p.checkdate"
                :promoId="p.id"
                :employeeId="v.employee"
              >{{ v.promos[p.id] | currency }}</sales-check-list-modal>
            </span>
            <span v-show="!v.promos.hasOwnProperty(p.id)">$0.00</span>
          </td>
          <td class="text-right">
            <span v-show="v.ptotal > 0">
              <sales-check-list-modal
                :locationId="locationId"
                :startDate="v.checkdate"
                :discountOnly="1"
                :employeeId="v.employee"
              >{{ v.ptotal | currency }}</sales-check-list-modal>
            </span>
            <span v-show="!v.ptotal > 0">$0.00</span>
          </td>
          <td class="text-right">{{ v.ptotalpct | number('00.00') }}%</td>
          <td class="text-right">
            <span v-show="v.voids > 0">
              <sales-check-list-modal
                :locationId="locationId"
                :startDate="v.checkdate"
                :voidOnly="1"
                :employeeId="v.employee"
              >{{ v.voids | currency }}</sales-check-list-modal>
            </span>
            <span v-show="!v.voids > 0">$0.00</span>
          </td>
          <td class="text-right">{{ v.voidspct | number('00.00') }}%</td>
          <td class="text-right">
            <span v-show="v.tiptotal > 0">
              <sales-check-list-modal
                :locationId="locationId"
                :startDate="v.checkdate"
                :employeeId="v.employee"
              >{{ v.tiptotal | currency }}</sales-check-list-modal>
            </span>
            <span v-show="!v.tiptotal > 0">$0.00</span>
          </td>
          <td class="text-right">{{ v.tiptotalpct | number('00.00') }}%</td>
        </tr>
        <tr class="border-right" v-show="!data.report.employees.length > 0">
          <td class="text-left" colspan="50">NO DATA AVAILABLE</td>
        </tr>
      </tbody>
      <tfoot v-show="data.report.employees.length > 0">
        <tr class="border-right">
          <td class="text-right">
            <strong>Totals:</strong>
          </td>
          <td class="text-right" v-for="p in data.report.promos" :key="p.id">
            <a
              href
              class="link"
              ng-click="fn.openCheckModal(null, null, 1, p.id)"
            >{{ p.ptotal | currency }}</a>
          </td>
          <td class="text-right">
            <a
              href
              class="link"
              ng-click="fn.openCheckModal(null, null, 1)"
            >{{ data.report.totalpromos | currency }}</a>
          </td>
          <td class="text-right">{{ data.report.totalpromospct | number('00.00') }}%</td>
          <td class="text-right">
            <a
              href
              class="link"
              ng-click="fn.openCheckModal(null, null, null, null, null, null, 1)"
            >{{ data.report.totalvoids | currency }}</a>
          </td>
          <td class="text-right">{{ data.report.totalvoidspct | number('00.00') }}%</td>
          <td class="text-right">
            <a
              href
              class="link"
              ng-click="fn.openCheckModal()"
            >{{ data.report.tiptotal | currency }}</a>
          </td>
          <td class="text-right">{{ data.report.tiptotalpct | number('00.00') }}%</td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import UserService from '@/services/UserService'
import DailyJournalReportService from '@/services/DailyJournalReportService'
import DailyReportTab from './dailyReportTab'
import salesCheckListModal from '@/components/modals/sales/salesCheckListModal'

export default {
  extends: DailyReportTab,
  components: {
    salesCheckListModal
  },
  data () {
    return {
      data: {
        loading: true,
        report: {
          employees: [],
          promos: []
        }
      },
      loadTimeout: null
    }
  },
  computed: {
    grossView: function () {
      return UserService.getConfigOption('gross_sales_view').value === 'yes'
    },
    checkGuestStats: function () {
      return UserService.getConfigOption('avg_check_guest_stats').value === 'yes'
    }
  },
  methods: {
    loadData: function () {
      if (this.isActive > 0 && this.loadTimeout === null) {
        this.loadTimeout = setTimeout(() => {
          this.$updateloading(1)
          this.data.loading = true
          DailyJournalReportService.getEmployeeSummary(this.locationId, this.dailyDate, (this.grossView ? 'gross' : 'net'))
            .then(res => {
              this.$updateloading(-1)
              this.data.loading = false
              this.data.report = res
              this.loadTimeout = null
            })
        }, 100)
      }
    }
  }
}
</script>
